import {SortOrder} from "antd/es/table/interface";

// Repeating the first direction keeps Ant Design from cycling into an unsorted state.
export const ascendingFirstSortDirections: SortOrder[] = ["ascend", "descend", "ascend"];
export const descendingFirstSortDirections: SortOrder[] = ["descend", "ascend", "descend"];
